import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAdminToken } from '@/lib/api';

export default function RequireAdmin({ children }) {
    const token = getAdminToken();
    if (!token) return <Navigate to="/admin/login" replace />;
    return children;
}
